import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Работа с PUSH")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Push токен")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Показать тестовое уведомление ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Запрос на обновление")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Требуется ли обновление ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Открыть окно ")

import { } from 'vue';
import uuid from 'uuid'
import { usePush } from '@/composables/push';
import { useAppCheckUpdate } from '@/composables/appCheckUpdate';
import { NotificationData } from '@/composables/notifications';
import { useToast } from '@/composables/useToast';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToast();

const push = usePush();
const pushToken = push.getToken() || '-';
// const pushTestSaveHistory = ref(false);

/**
 * Отображает тестовое сообщение (не сохраняется в истории)
 */
function testPushMessage() {
  const id = uuid.v1();
  const notification: NotificationData = {
    id: id,
    title: `Уведомление ID:${id} пример`,
    body: `Короткий текст уведомления ID:${id} новое https://core12.ru/ \n текст на новой строке`,
    meta: {},
    createAt: new Date(),
  };

  push.eventBus.emit('notification', notification);

  // if (pushTestSaveHistory.value) {
  //   push.eventBus.emit('mergeNotification', notification);
  // }
}

const appUpdate = useAppCheckUpdate();
async function showCheckAppUpdate() {
  const isUpd = await appUpdate.isNeedsUpdating();

  if (isUpd) {
    toast.warning('Требуется обновление!');
  } else {
    toast.success(isUpd ? 'Требуется обновление!' : 'Обновление НЕ требуется.');
  }
}


return (_ctx: any,_cache: any) => {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_app_header, { title: "Development" }),
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "floating" }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        value: _unref(pushToken),
                        readonly: true
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    class: "ion-margin-top",
                    expand: "block",
                    onClick: testPushMessage
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    fill: "clear",
                    expand: "block",
                    onClick: showCheckAppUpdate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    onClick: _unref(appUpdate).showModalInformation
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer)
    ]),
    _: 1
  }))
}
}

})